import { Injectable, Injector, isDevMode } from '@angular/core';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { environment } from '@env/environment';
import { Amplify } from 'aws-amplify';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { LoaderService } from '../loader/loader.service';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { loginStoreActions } from '@app/root-store';
import { Store } from '@ngrx/store';
import { Location } from '@angular/common';
import { get, patch, post, put, del as deleteApi } from '@aws-amplify/api';
import { fetchAuthSession } from '@aws-amplify/auth';
@Injectable()
export class AmplifyHttpClient {
  reqCount: number = 0;
  resCount: number = 0;
  currentURL;
  authNeeded = true;
  loaderTypes = loaderTypes;

  constructor(
    private loaderService: LoaderService,
    private injector: Injector,
    private _store: Store,
    private location: Location,
    private _router: Router,
    private toastr: ToastrService
  ) {
    this.currentURL = window.location.href.split('/');
    if (this.currentURL[3] === 'external') {
      this.authNeeded = false;
    }
    // Amplify.configure({
    //   API: {
    //     REST: {
    //       APIGateway: {
    //         endpoint: environment.apiUrl,
    //         region: environment.region,
    //       },
    //     },
    //   },
    // });
  }

  get<T>(url: string, params: any = null, loader?: loaderTypes): Observable<any> {
    this.log(['calling:', url], 'info');
    this.showLoader(loader);
    this.reqCount++;
    return new Observable((subscriber) => {
      (async () => {
        try {
          const session = await fetchAuthSession();
          const token = session.tokens?.idToken?.toString();

          const restOperation = await get({
            apiName: 'api',
            path: '/' + url,
            options: {
              queryParams: params?.params || null,
              headers: {
                Authorization: `Bearer ${token}`,
              },
              retryStrategy: {
                strategy: 'no-retry',
              },
            },
          });
          const response = await restOperation.response;
          const data = await response.body.json();

          subscriber.next(data);
          this.resCount++;
          this.onEnd();
        } catch (error) {
          this.resCount++;
          this.onEnd();
          subscriber.next(error);
          this.log(['failed to call:', url, error], 'error');
        }
      })();
    });
  }

  post<T>(url, body = null, loader?: loaderTypes): Observable<any> {
    this.log(['calling:', url], 'info');
    this.showLoader(loader);
    this.reqCount++;
    return new Observable((subscriber) => {
      (async () => {
        try {
          const session = await fetchAuthSession();
          const token = session.tokens?.idToken?.toString();

          const restOperation = post({
            apiName: 'api',
            path: '/' + url,
            options: {
              body,
              headers: {
                Authorization: `Bearer ${token}`,
              },
              retryStrategy: {
                strategy: 'no-retry',
              },
            },
          });

          const response = await restOperation.response;
          const data = await response.body.json();
          subscriber.next(data);
          this.resCount++;
          this.onEnd();
        } catch (error) {
          this.resCount++;
          this.onEnd();
          subscriber.next(error);
          this.log(['failed to call:', url, error], 'error');
        }
      })();
    });
  }

  post_promise(url, body = null, loader?: loaderTypes) {
    this.log(['calling:', url], 'info');
    this.showLoader(loader);
    this.reqCount++;
    return (async () => {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();

        const restOperation = post({
          apiName: 'api',
          path: '/' + url,
          options: {
            body,
            headers: {
              Authorization: `Bearer ${token}`,
            },
            retryStrategy: {
              strategy: 'no-retry',
            },
          },
        });

        const response = await restOperation.response;
        const data = await response.body.json();
        this.resCount++;
        this.onEnd();
        return data;
      } catch (error) {
        this.resCount++;
        this.onEnd();
        this.log(['failed to call:', url, error], 'error');
        throw error;
      }
    })();
  }

  patch<T>(url, body = null, loader?: loaderTypes): Observable<any> {
    this.log(['calling:', url], 'info');
    this.showLoader(loader);
    this.reqCount++;
    return new Observable((subscriber) => {
      (async () => {
        try {
          const session = await fetchAuthSession();
          const token = session.tokens?.idToken?.toString();

          const restOperation = patch({
            apiName: 'api',
            path: '/' + url,
            options: {
              body,
              headers: {
                Authorization: `Bearer ${token}`,
              },
              retryStrategy: {
                strategy: 'no-retry',
              },
            },
          });

          const response = await restOperation.response;
          const data = await response.body.json();
          subscriber.next(data);
          this.resCount++;
          this.onEnd();
        } catch (error) {
          this.resCount++;
          this.onEnd();
          subscriber.next(error);
          this.log(['failed to call:', url, error], 'error');
        }
      })();
    });
  }

  delete<T>(url, body = null, loader?: loaderTypes): Observable<any> {
    this.log(['calling:', url], 'info');
    this.showLoader(loader);
    this.reqCount++;
    return new Observable((subscriber) => {
      (async () => {
        try {
          const session = await fetchAuthSession();
          const token = session.tokens?.idToken?.toString();

          const restOperation = deleteApi({
            apiName: 'api',
            path: '/' + url,
            options: {
              headers: {
                Authorization: `Bearer ${token}`,
              },
              retryStrategy: {
                strategy: 'no-retry',
              },
            },
          });

          const response = await restOperation.response;
          subscriber.next(response);
          this.resCount++;
          this.onEnd();
        } catch (error) {
          this.resCount++;
          this.onEnd();
          subscriber.next(error);
          this.log(['failed to call:', url, error], 'error');
        }
      })();
    });
  }

  put<T>(url, body = null, loader?: loaderTypes): Observable<any> {
    this.log(['calling:', url], 'info');
    this.showLoader(loader);
    this.reqCount++;
    return new Observable((subscriber) => {
      (async () => {
        try {
          const session = await fetchAuthSession();
          const token = session.tokens?.idToken?.toString();

          const restOperation = put({
            apiName: 'api',
            path: '/' + url,
            options: {
              body,
              headers: {
                Authorization: `Bearer ${token}`,
              },
              retryStrategy: {
                strategy: 'no-retry',
              },
            },
          });

          const response = await restOperation.response;
          const data = await response.body.json();
          subscriber.next(data);
          this.resCount++;
          this.onEnd();
        } catch (error) {
          this.resCount++;
          this.onEnd();
          subscriber.next(error);
          this.log(['failed to call:', url, error], 'error');
        }
      })();
    });
  }
  private log(logMessage, type) {
    //this seems to be causing some issues. Even invalid errors seem to be popping up.
    // For now commeting it out.
    if (type === 'error') {
      this.needToMoveLoginPage(logMessage);
      if (logMessage[2].message === 'Network Error') {
        //this.toastr.error('Your access to the Internet seems to be disconnected. Please try again later');
      } else {
        this.toastr.error('Something seems to be wrong. Please try again later. If the problem persists please contact admin@kinnect.us');
      }
    }
  }

  private onEnd(): void {
    if (this.reqCount === this.resCount) {
      this.hideLoader();
    }
  }

  private showLoader(loader: loaderTypes): void {
    if (loader !== loaderTypes.none) {
      this.loaderService.show(loader);
    } else if (loader === loaderTypes.none || !loader) {
      this.loaderService.hide();
    }
  }

  public hideLoader(): void {
    this.loaderService.hide();
  }
  needToMoveLoginPage(error) {
    this.hideLoader();
    if (error[2].toJSON()['status'] == 401) {
      const authService = this.injector.get(AuthService);
      authService.logout().subscribe(
        () => {
          // logout dispacth Ngrx
          this._store.dispatch(new loginStoreActions.LogoutSuccessAction());
          this._router.navigateByUrl('/').then(() => {
            this.location.go(this._router.url); // Update the browser's URL
            window.location.reload(); // Reload the page
          });
        },
        (error: any) => {
          this.toastr.error(error.error.message);
          return false;
        }
      );
    }
  }
}
